<template>
  <div class="Order">
    <ui-sidebar></ui-sidebar>
    <div class="rightBox clearfix">
      <ui-topbar class="d-none d-lg-block"></ui-topbar>
      <ui-center></ui-center>
      <ui-footer></ui-footer>
    </div>
  </div>
</template>

<script>
import Topbar from '@/components/layout/Topbar.vue';
import Sidebar from '@/components/layout/Sidebar.vue';
import Footer from '@/components/layout/Footer.vue';
import Center from '@/components/order/Center.vue';

export default {
  name: 'Order',
  components: {
    'ui-sidebar': Sidebar,
    'ui-footer': Footer,
    'ui-topbar': Topbar,
    'ui-center': Center
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  }
}
</script>

<style scoped lang='less'>
.Order {
  display: flex;
  .rightBox{
    flex: 1;
    margin-left: 50px;
  }
}
@media (max-width: 1200px) {
  .Order{
    div.rightBox{
      margin-left: 30px;
    }
  }
}
@media (max-width: 992px) {
  .Order{
    display: flex;
    flex-direction: column;
    div.rightBox{
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/Order.vue